import { defineMessages } from 'react-intl';
import { TEAM_MEMBER_CONNECTION_STATUSES } from 'store/features/company-team-member-connections/helpers';

export const connectionStatuses = defineMessages({
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingSignUpByUser]: {
    id: 'admin.companies.teams.connections.statuses.pending-sign-up',
    defaultMessage: 'Pending Signup',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingEthAddressFromUser]: {
    id: 'admin.companies.teams.connections.statuses.pending-eth-address',
    defaultMessage: 'Pending Eth Address',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByUser]: {
    id: 'admin.companies.teams.connections.statuses.pending-transaction-signing-by-user',
    defaultMessage: 'Pending',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByCompany]: {
    id: 'admin.companies.teams.connections.statuses.pending-transaction-signing-by-company',
    defaultMessage: 'Pending',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.pendingTransactionSigningByBoth]: {
    id: 'admin.companies.teams.connections.statuses.pending-transaction-signing-by-both',
    defaultMessage: 'Pending',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.signedByBoth]: {
    id: 'admin.companies.teams.connections.statuses.signed',
    defaultMessage: 'Verified',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.rejectedByUser]: {
    id: 'admin.companies.teams.connections.statuses.rejected',
    defaultMessage: 'Rejected',
  },
  [TEAM_MEMBER_CONNECTION_STATUSES.unknown]: {
    id: 'admin.companies.teams.connections.statuses.unknown',
    defaultMessage: 'Unknown',
  },
});

export const connectionActions = defineMessages({
  confirmRevoke: {
    id: 'admin.companies.teams.connections.invitation.revoke',
    defaultMessage: `<p class="lead">Are you sure you want to reject team member connection to <strong>{companyName}</strong>?</p>`,
  },
  revoked: {
    id: 'admin.companies.teams.connections.invitation.revoked',
    defaultMessage: `You are no longer a team member for {companyName}`,
  },
  confirmReject: {
    id: 'admin.companies.teams.connections.invitation.reject',
    defaultMessage: `<p class="lead">Are you sure you want to reject team member invitation from <strong>{companyName}</strong>?</p>`,
  },
  rejected: {
    id: 'admin.companies.teams.connections.invitation.rejected',
    defaultMessage: `You have rejected an team member connection request from {companyName}`,
  },
});



// WEBPACK FOOTER //
// ./src/ui/users/team-memberships/messages.js